import React, {useState, useEffect, useContext}  from 'react';
import { JsonRpc } from 'eosjs';
import { PrivateKey } from "eosjs/dist/eosjs-jssig";

import Context from '../../context';
import {sign} from '../../api';
import {DEFAULT_CONFIG} from '../../api/config';
import {redemptionCodeToPrivateKey, publicKeyToPrimaryKey} from '../../api/crypto';
import { CongratsBlock } from '../congrats-block';
import ActionForm from '../action-form';

const fetch = require('node-fetch');

const rpc = new JsonRpc('https://wax.pink.gg', { fetch });

const RedeemCode = () => {
  const [value, setValue] = useState('');
  const [isValid, setIsValid] = useState(false);
  const [congrats, setCongrats] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const { wax } = useContext(Context);

  useEffect(() => {
    let params = (new URL(window.location)).searchParams; 
    let code = params.get("code");
    if(code) {
      setValue(code)
    }
  }, []);


  const handlerCheckCode = (event) => {
    event.preventDefault()
    const privatKey =redemptionCodeToPrivateKey(value);
    const publicKey = PrivateKey.fromString(privatKey).getPublicKey().toString();
    const primaryKey = publicKeyToPrimaryKey(publicKey);

    let checkCode = {};
    if(value) {
      (async () => {
        try {
          checkCode = await rpc.get_table_rows({
            json: true,
            code: DEFAULT_CONFIG.account,
            scope: DEFAULT_CONFIG.drop_id,
            table: DEFAULT_CONFIG.table,
            lower_bound: primaryKey,
            upper_bound: primaryKey,
            limit: 1,
            reverse: false,
            show_payer: false,
          });
          const [rows] = checkCode.rows;
          if (!rows || rows.counter === 1) {
            setErrorMessage('Wrong code or it has already been used')
            return
          } else {
            setErrorMessage('')
            setIsValid(true);
          }
        } catch(e) {
          setErrorMessage(e.message)
        }
      })();
    };
  }

  const handlerRedeemCode = (event) => {
    event.preventDefault()
    if(value) {
      const privatKey =redemptionCodeToPrivateKey(value);
      const publicKey = PrivateKey.fromString(privatKey).getPublicKey().toString();
      const signature = PrivateKey.fromString(privatKey).sign(DEFAULT_CONFIG.drop_id + '-' + wax.userAccount + '-' + DEFAULT_CONFIG.nonce).toString();

      (async () => {
        try {
          await sign(wax, publicKey, signature, setCongrats, setIsValid, setErrorMessage)
          setValue('');
          setIsValid(true)
        } catch(e) {
          console.log(e.message)
        }
      })();
    }
  };

  return (
    <>
      {congrats 
        ? <CongratsBlock /> 
        : <ActionForm 
            isValid={isValid}
            setIsValid={setIsValid}
            handlerForm={isValid ? handlerRedeemCode : handlerCheckCode} 
            value={value} 
            setValue={setValue}
            errorMessage={errorMessage}
          />
      }
    </>
  )
};

export default RedeemCode;